import React from "react";
import "./AboutUs.css"; // CSS file for styling
import "../App.css"; // CSS file for styling

const AboutUs = () => {
  const cardsData = [
    {
      title: "Our Mission",
      text: "Our mission is to provide the best solutions that help our clients realize their dreams. We strive to work with multiple stakeholders providing only the optimal benefits to our clients.",
    },
    {
      title: "Our Vision",
      text: "We see ourselves taking the ownership for fulfilling the dreams and aspirations of our customers. We want to provide the best investment sources and better options for our clients. It is our vision to get ranked on top for customer satisfaction in financial guidance industry.",
    },
    {
      title: "Our Approach",
      text: "Our approach involves researching the available products and analyzes the existing financial investments of the clients before arriving at a solution that matches the current and the future requirements. We take both short and long term objectives into account.",
    },
    {
      title: "Our USP",
      text: "Not everyone can benefit from simple off the shelf solutions as the financial needs and the budget of every person is unique. We therefore create customized solutions that befit everyone’s budget and the needs of their family.",
    },
  ];

  return (
    <div className="page about-page">
      <header className="about-header">
        <h1>About Us</h1>
        <p>
          At <b className="services-bold">United Investment Point</b>, we are a
          leading organization dedicated to delivering comprehensive financial
          services tailored to meet our clients' unique needs. Our expertise
          spans a wide range of areas, including retirement guidance, asset
          management, tax guidance, and more. We proudly serve a diverse
          clientele, including corporate organizations, individual investors,
          and NRIs, across various industries.
        </p>
        <p>
          Our strong foundation is built on the trust and loyalty of our
          clients, strengthened by the meaningful relationships we cultivate.
          Our team comprises highly qualified and experienced professionals,
          committed to helping you grow your wealth and achieve financial
          stability. We aim to ensure that your investments work efficiently for
          you, even amidst market uncertainties.
        </p>
        <p>
          What sets us apart is our unwavering commitment to delivering
          personalized service and bespoke solutions. You can rely on us to
          provide steadfast support and expert guidance, regardless of market
          fluctuations. We believe in empowering you to dream bigger, because
          the dreams you envision today pave the way for a brighter tomorrow.
        </p>
      </header>
      <section className="about-cards">
        {cardsData.map((card, index) => (
          <div className="card" key={index}>
            <h3 className="card-title">{card.title}</h3>
            <p className="card-text">{card.text}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default AboutUs;
